// extracted by mini-css-extract-plugin
export var active = "_ik-e";
export var blink = "_ik-f";
export var dropDownSelector = "_ik-5";
export var dropDownWrapper = "_ik-4";
export var fakeCursor = "_ik-d";
export var fontSizeButton = "_ik-7";
export var formQuillEditor = "_ik-0";
export var pressed = "_ik-g";
export var qlBlank = "_ik-1";
export var textFormattingToolbar = "_ik-2";
export var textFormattingToolbarClosed = "_ik-3";
export var textFormattingToolbarInline = "_ik-6";
export var textToolbarOption = "_ik-8";
export var toolbarCell = "_ik-a";
export var toolbarCellCollapsed = "_ik-b";
export var toolbarOptionHitArea = "_ik-c";
export var toolbarOverflow = "_ik-9";